/**
* Video Transition JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Transition component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'video-transition',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const query = window.matchMedia( '(prefers-reduced-motion: reduce)' );

      if ( !query.matches && window.innerWidth >= 1024 ) {
        const headerHeight = $( 'header.navbar' ).height();
        let top = headerHeight;
        if ( $( 'body.logged-in' ).length > 0 ) {
          top += 32;
        }
        $( '.video-transition' ).each( function() {
          const container = $( this ).find( '.video-transition__container' );
          const containerRight = container.offset().left + 50;

          const video = $( this ).find( '.video-transition__video' );
          const content = $( this ).find( '.video-transition__content' );

          video.css( 'position', 'absolute' );
          video.css( 'right', containerRight+'px' );
          video.css( 'bottom', '48px' );

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: `top top+=${top}`,
              end: `bottom top-=200`,
              pin: true,
              scrub: true,
              // markers: true,
              invalidateOnRefresh: true,
            },
          } );

          tl.fromTo( video, {width: '469px', height: '222px'}, {width: '100vw', left: 0, right: 0, top: 0, bottom: 0, padding: 0, height: '100%'} );
          tl.to( content, {yPercent: -100, opacity: 0}, '<' );
        } );
      } else {
        $( '.video-transition' ).each( function() {
          const videoWrapper = $( this ).find( '.video-transition__video-wrapper' );
          videoWrapper.css( 'position', 'relative' );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-transition', COMPONENT );
} )( app );
